export default "__VITE_ASSET__DZpaUpX3__"